/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Collaborators_Createnewrole2Inputs */

const en_settings_collaborators_createnewrole2 = /** @type {(inputs: Settings_Collaborators_Createnewrole2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create new role`)
};

/**
* | output |
* | --- |
* | "Create new role" |
*
* @param {Settings_Collaborators_Createnewrole2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_createnewrole2 = /** @type {((inputs?: Settings_Collaborators_Createnewrole2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Createnewrole2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_createnewrole2(inputs)
});
export { settings_collaborators_createnewrole2 as "settings_collaborators_createNewRole" }